import { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Alert, Box, Snackbar, Theme, ThemeProvider, createTheme } from "@mui/material";
import { Header } from "../../components/Header";
import views, { View } from "../../data/views.data";
import { LeftSidebar } from "../../components/LeftSidebar";
import VspPortalContext from "../../store/VspPortalContext";
import { NotificationTypes } from "../../enums/NotificationTypes";
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useAuth } from "../../auth/useAuth";
import { InteractionStatus, AccountInfo } from "@azure/msal-browser";
import { AuthPlaceholder } from "../../components/AuthPlaceholder";
import { AccessDenied } from "../../components/AccessDenied";
import { Home } from "../Home";
import { VspPortalActions } from "../../store/VspPortalActions";


const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ff5722'
    }
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff5722'
    }
  }
});

const mainSx = {
  flexGrow: 1,
  paddingTop: '48px',
};


export const Views: React.FC = ( ) => {

  const [ drawerOpen, setDrawerOpen ] = useState( false );
  const [ isAuthorized, setIsAuthorized ] = useState<boolean>( false );
  const [ theme, setTheme ] = useState<Theme>( lightTheme );

  const { state, dispatch } = useContext( VspPortalContext );

  const routes = views
    .filter( (view: View) => view.userGroups.filter( e => state.userGroups.includes ( e ) ).length > 0 || view.userGroups.length === 0 )
    .map( (view: View) => <Route path={view.path} element={view.component} key={view.index}/> );

  const { accounts, inProgress } = useMsal( );
  const isAuthenticated: boolean = useIsAuthenticated( );
  const accountInfo = useAccount( accounts[0] );
  const { authorize } = useAuth( );


  useEffect( ( ) => {

    const doAuthorization = async ( ) => setIsAuthorized( await authorize( ) ); 

    if ( isAuthenticated && inProgress === InteractionStatus.None ) {
      
      doAuthorization(  );

    }

  }, [ isAuthenticated, inProgress ] );


  useEffect( ( ) => {

    if( state.isDarkTheme ) {

      setTheme( darkTheme );

    } else {

      setTheme( lightTheme );

    }


  }, [ state.isDarkTheme ]);


  const getUserName = ( accountInfo: AccountInfo | null ) => {

    if( accountInfo?.name ) {

      return accountInfo?.name;
  
    }
  
    return '';

  };

  return (


    <>

      { ( !isAuthenticated || inProgress !== InteractionStatus.None ) && <AuthPlaceholder /> }

      { ( isAuthenticated && inProgress === InteractionStatus.None && !isAuthorized ) && <AccessDenied /> }

      { 

        ( isAuthenticated && inProgress === InteractionStatus.None && isAuthorized ) 
          && 
        <ThemeProvider theme={ theme }>
        
          <div style={{ display: 'flex', height: '100vh' }} >

            <Header openDrawer={ ( ) => setDrawerOpen( true )} userName={ getUserName( accountInfo ) } />
            <LeftSidebar drawerOpen={ drawerOpen } closeDrawer={() => setDrawerOpen( false )}/>

            <Box component="main" sx={{ ...mainSx, ...(drawerOpen && { marginLeft: '300px;',  transition: 'margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)' }) }}>
              <Routes>
                { routes }
                <Route path="*" element={<Home />} />
              </Routes>
            </Box>

            <Snackbar open={ state.notificationText !== '' } autoHideDuration={state.notificationType === NotificationTypes.Error ? null : 6000} onClose={() => dispatch({ type: VspPortalActions.SetNotificationText, payload: '' })}>
                <Alert onClose={ ( ) => dispatch({ type: VspPortalActions.SetNotificationText, payload: '' }) } severity={ state.notificationType } sx={{ width: '100%' }}>
                  { state.notificationText }
                </Alert>
            </Snackbar>

          </div>

        </ThemeProvider>

      }

    </>
  
  );

};